import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../../redux/actions'
import autobind from 'react-autobind'
import { withRouter } from 'react-router-dom';
import { compose, withProps, lifecycle } from 'recompose'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import { SearchBox } from "react-google-maps/lib/components/places/SearchBox";
import _ from 'lodash'
import Dialog from './../../components/Dialog/Dialog';
import FilterSorter from './../../components/FilterSorter';
import NotificationListItem from './../../components/Notification/NotificationListItem'
import Dropzone from 'react-dropzone';
import Header from './../../components/Header';
import Subheader from './../../components/Subheader';
import Alert from './../../components/Errors/Alert'
import Footer from './../../components/Footer';
import { Modal, ModalBody } from 'reactstrap';
import Select from 'react-select';

/*global google:true*/
const MapWithASearchBox = compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBGivnjnSrzq-vZNKBIlfhOMxyTlZb9YB0&v=3.exp&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />,
        mapElement: <div style={{ height: `100%` }} />,
    }),
    lifecycle({
        componentWillMount() {
            const refs = {}

            this.setState({
                bounds: null,
                center: {
                    lat: 45.756817, lng: 21.227746
                },
                markers: [],
                onMapMounted: ref => {
                    refs.map = ref;
                },
                onIdle: () => {
                    this.setState({
                        bounds: refs.map.getBounds(),
                        center: refs.map.getCenter(),
                    })
                },
                onSearchBoxMounted: ref => {
                    refs.searchBox = ref;
                },
                onMapClick: e => {
                    const latLng = e.latLng;
                    // const lat = latLng.lat();
                    // const lng = latLng.lng();
                    this.setState({
                        markers: [
                            new google.maps.Marker({
                                position: latLng
                            })
                        ]
                    })
                },
                onPlacesChanged: () => {
                    const places = refs.searchBox.getPlaces();
                    const bounds = new google.maps.LatLngBounds();

                    places.forEach(place => {
                        if (place.geometry.viewport) {
                            bounds.union(place.geometry.viewport)
                        } else {
                            bounds.extend(place.geometry.location)
                        }
                    });
                    const nextMarkers = places.map(place => ({
                        position: place.geometry.location,
                    }));
                    const nextCenter = _.get(nextMarkers, '0.position', this.state.center);

                    this.setState({
                        center: nextCenter,
                        markers: nextMarkers,
                    });
                    // refs.map.fitBounds(bounds);
                },
            })
        },
    }),
    withScriptjs,
    withGoogleMap
)(props => {

    if (props.markers[0]) {
        props.onSetMarker(props.markers[0].position);
    }

    return <GoogleMap
        ref={props.onMapMounted}
        defaultZoom={15}
        onClick={props.onMapClick}
        center={props.center}
        onIdle={props.onIdle} >
        <SearchBox
            ref={props.onSearchBoxMounted}
            bounds={props.bounds}
            controlPosition={google.maps.ControlPosition.TOP_LEFT}
            onPlacesChanged={props.onPlacesChanged} >
            <input
                type="text"
                placeholder="Search for a street name..."
                style={{
                    boxSizing: `border-box`,
                    border: `1px solid transparent`,
                    width: `400px`,
                    height: `32px`,
                    marginTop: `10px`,
                    padding: `0 12px`,
                    borderRadius: `3px`,
                    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                    fontSize: `14px`,
                    outline: `none`,
                    textOverflow: `ellipses`,
                }}
            />
        </SearchBox>
        {props.markers.map((marker, index) =>
            <Marker key={index} position={marker.position} />
        )}
    </GoogleMap>
}

);
const sortFuncGen = (property, direction) => {
    const up = direction === "asc" ? 1 : -1
        , down = direction === "asc" ? -1 : 1
    return ((a, b) => {
        return a.data[property] < b.data[property] ? down : up
    })
}

class NotificationsPage extends PureComponent {

    constructor(props) {
        super(props);
        autobind(this);

        this.sortbyItems = [
            { name: "Range (desc)", sortFunc: sortFuncGen("distance", "desc"), onSelect: this.sortby },
            { name: "Range (asc)", sortFunc: sortFuncGen("distance", "asc"), onSelect: this.sortby },
        ]

        this.filterByItems = [
            { name: "All", filterFunc: (i) => true, onSelect: this.filterby },
            { name: "Published", filterFunc: (i) => i.active, onSelect: this.filterby },
            { name: "Unpublished", filterFunc: (i) => !i.active, onSelect: this.filterby },
        ]
        this.categoryFilterItems = [
            { name: "All", filterFunc: (i) => true, onSelect: this.categfilterby },
        ]

        this.state = this._props2state(props, {

            categoryOptions: [],
            searchedNotifications: null,
            // new notification
            newNotificationModalOpen: false,
            name: '',
            latitude: '',
            longitude: '',
            radius: '',
            address: '',
            details: '',
            link: '',
            phone: '',
            email: '',
            category: null,
            acceptedNotificationImage: [],
            rejectedNotificationImage: [],

            // edit notification
            editNotificationModalOpen: false,
            notificationIdEdit: null,
            nameEdit: '',
            latitudeEdit: '',
            longitudeEdit: '',
            radiusEdit: '',
            addressEdit: '',
            detailsEdit: '',
            linkEdit: '',
            phoneEdit: '',
            emailEdit: '',
            categoryEdit: null,
            acceptedNotificationImageEdit: [],
            rejectedNotificationImageEdit: [],

            // list
            notifications: [],

            // delete & confirm
            toDeleteNotificationId: null,
            confirmDeleteModalOpen: false,
            sortByIndex: 0,
            filterByIndex: 0,
            categoryFilterIndex: 0,
            filteredProducts: []
        })

    }

    componentDidMount() {

        this.props.getNotifications()

        this.props.getNotificationCategories()
    }

    componentWillReceiveProps(props) {
        this.setState(this._props2state(props, this.state))
    }

    _props2state(props, state) {

        const { categories, notifications } = props

        const { filterByIndex, sortByIndex } = state

        let newState = { ...state }

        if (notifications && notifications.length) {

            newState.notifications = notifications.map((notification) => {
                return {
                    data: notification,
                    active: notification.active
                }
            })

            const categs = notifications.reduce((p, c) => {
                if (-1 === p.findIndex(x => x._id === c.category._id))
                    p.push(c.category)
                return p
            }, []).sort((a, b) => a.sortIndex - b.sortIndex)

            newState.filteredProducts = (newState.notifications || []).slice(0).sort(this.sortbyItems[sortByIndex].sortFunc).filter(this.filterByItems[filterByIndex].filterFunc)

            this.categoryFilterItems = [
                this.categoryFilterItems[0],
                ...categs.map(c => ({
                    name: c.name, filterFunc: (p) => p.data.category._id === c._id, onSelect: this.categfilterby
                }))
            ]

            newState.categoryFilterIndex = 0
        } else {
            newState.notifications = []
        }

        if (categories && categories.length) {

            newState.categoryOptions = categories.sort((a, b) => a.sortIndex - b.sortIndex).map((category) => {
                return { value: category._id, label: category.name };
            })
            newState.category = newState.categoryOptions[0]
        }

        if (!props.addNotificationError && !props.adding)
            newState.newNotificationModalOpen = false

        if (!props.editNotificationError && !props.editing)
            newState.editNotificationModalOpen = false


        return newState

    }

    getSubscriptionByDomainConstantCanUpload(constant) {
        const subscriptions = _.filter(this.props.subscriptions, (subscription) => {
            return subscription.domain.constant === constant
        })

        if (subscriptions.length) {
            return subscriptions[0].canUpload
        }

        return false
    }

    toggleNewNotificationModalOpen() {
        this.setState({
            newNotificationModalOpen: !this.state.newNotificationModalOpen
            , name: '', latitude: '', longitude: '', radius: '', link: '', details: '', phone: '', email: '', acceptedNotificationImage: []
        })
    }

    toggleEditNotificationModalOpen() {
        this.setState({
            editNotificationModalOpen: !this.state.editNotificationModalOpen
        });
    }

    updateLocation(position) {

        fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + position.lat() + ',' + position.lng() + '&key=AIzaSyBGivnjnSrzq-vZNKBIlfhOMxyTlZb9YB0',
            {
                method: 'GET',
            })
            .then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    address: responseJson.results[0].formatted_address
                })
            })
            .catch((error) => {
                console.log(error)
            })

        this.setState({
            latitude: position.lat(),
            longitude: position.lng(),
        })
    }

    updateRadius(e) {
        this.setState({
            radius: e.target.value
        })
    }

    updateDetails(e) {
        this.setState({
            details: e.target.value
        })
    }

    updateCategory(selectedOption) {
        this.setState({
            category: selectedOption
        })
    }

    updateLink(e) {
        this.setState({
            link: e.target.value
        })
    }

    updateName(e) {
        this.setState({
            name: e.target.value
        })
    }

    updatePhone(e) {
        this.setState({
            phone: e.target.value
        })
    }

    updateEmail(e) {
        this.setState({
            email: e.target.value
        })
    }

    updateLocationEdit(position) {

        fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + position.lat() + ',' + position.lng() + '&key=AIzaSyBGivnjnSrzq-vZNKBIlfhOMxyTlZb9YB0',
            {
                method: 'GET',
            })
            .then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    addressEdit: responseJson.results[0].formatted_address
                })
            })
            .catch((error) => {
                console.log(error)
            })

        this.setState({
            latitudeEdit: position.lat(),
            longitudeEdit: position.lng(),
        })
    }

    updateRadiusEdit(e) {
        this.setState({
            radiusEdit: e.target.value
        })
    }

    updateDetailsEdit(e) {
        this.setState({
            detailsEdit: e.target.value
        })
    }

    updateCategoryEdit(selectedOption) {
        this.setState({
            categoryEdit: selectedOption
        })
    }

    updateLinkEdit(e) {
        this.setState({
            linkEdit: e.target.value
        })
    }

    updateNameEdit(e) {
        this.setState({
            nameEdit: e.target.value
        })
    }

    updatePhoneEdit(e) {
        this.setState({
            phoneEdit: e.target.value
        })
    }

    updateEmailEdit(e) {
        this.setState({
            emailEdit: e.target.value
        })
    }

    onDropNotificationImageEdit(acceptedFiles, rejectedFiles) {
        this.setState({
            acceptedNotificationImageEdit: acceptedFiles,
            rejectedNotificationImageEdit: rejectedFiles
        });
    }

    addNewNotification() {
        const { name, address, latitude, longitude, radius, details, link, acceptedNotificationImage, category, phone, email } = this.state
        this.props.addNotification(name, address, latitude, longitude, radius, link, details, acceptedNotificationImage[0], category.value, phone, email)
    }

    onDropNotificationImage(acceptedFiles, rejectedFiles) {
        this.setState({
            acceptedNotificationImage: acceptedFiles,
            rejectedNotificationImage: rejectedFiles
        });
    }

    onActiveSwitch(notificationId) {
        this.props.toggleNotification(notificationId)
    }

    confirmDeleteModalProceed() {
        const { toDeleteNotificationId } = this.state
        this.confirmDeleteModalHide()
        if (toDeleteNotificationId) {
            this.props.deleteNotification(toDeleteNotificationId)
        }
    }

    confirmDeleteModalShow(notificationId) {
        this.setState({
            toDeleteNotificationId: notificationId,
            confirmDeleteModalOpen: true
        })
    }

    confirmDeleteModalHide() {
        this.setState({
            confirmDeleteModalOpen: false
        })
    }

    editNotification(notificationId) {
        const notification = this.state.notifications.find((notification) => {
            return notificationId === notification.data._id
        })

        const { data } = notification

        this.setState({
            notificationIdEdit: data._id,
            nameEdit: data.locationName,
            latitudeEdit: data.latitude,
            longitudeEdit: data.longitude,
            radiusEdit: data.distance,
            addressEdit: data.address,
            detailsEdit: data.details,
            linkEdit: data.link,
            phoneEdit: data.phone,
            emailEdit: data.email,
            categoryEdit: this.state.categoryOptions.find(co => co.value === data.category._id),
            editNotificationModalOpen: true
        })
    }

    editNotificationConfirm() {

        const { notificationIdEdit, nameEdit, latitudeEdit, longitudeEdit, radiusEdit, addressEdit, detailsEdit, linkEdit, phoneEdit, emailEdit, categoryEdit, acceptedNotificationImageEdit } = this.state

        this.props.updateNotification(notificationIdEdit, {
            locationName: nameEdit,
            latitude: latitudeEdit,
            longitude: longitudeEdit,
            distance: radiusEdit,
            address: addressEdit,
            details: detailsEdit,
            link: linkEdit,
            phone: phoneEdit,
            email: emailEdit,
            category: categoryEdit.value,
            picture: acceptedNotificationImageEdit.length ? acceptedNotificationImageEdit[0] : null
        }, true, () => {
            this.setState({
                editNotificationModalOpen: false
            })
            this.getNotifications()
        })
    }

    onSearch(keywords) {
        if (keywords.length < 3) {
            return this.setState({ searchedNotifications: null })
        }
        const { notifications } = this.state
            , rex = new RegExp(`${keywords}`, 'gi')
            , searchedNotifications = notifications.filter(n => rex.test(n.data.locationName) || rex.test(n.data.link) || rex.test(n.data.address))
        this.setState({ searchedNotifications })
    }

    sortby(sortByIndex) {
        const { filterByIndex, categoryFilterIndex } = this.state
            , { notifications } = this.state
            , filteredProducts = (notifications || []).slice(0)
                .sort(this.sortbyItems[sortByIndex].sortFunc)
                .filter(this.categoryFilterItems[categoryFilterIndex].filterFunc)
                .filter(this.filterByItems[filterByIndex].filterFunc)
        this.setState({ filteredProducts, sortByIndex })
    }

    filterby(filterByIndex) {
        const { sortByIndex, categoryFilterIndex } = this.state
            , { notifications } = this.state
            , filteredProducts = (notifications || []).slice(0)
                .sort(this.sortbyItems[sortByIndex].sortFunc)
                .filter(this.categoryFilterItems[categoryFilterIndex].filterFunc)
                .filter(this.filterByItems[filterByIndex].filterFunc)
        this.setState({ filteredProducts, filterByIndex })
    }

    categfilterby(categoryFilterIndex) {
        const { sortByIndex, filterByIndex } = this.state
            , { notifications } = this.state
            , filteredProducts = (notifications || []).slice(0)
                .sort(this.sortbyItems[sortByIndex].sortFunc)
                .filter(this.categoryFilterItems[categoryFilterIndex].filterFunc)
                .filter(this.filterByItems[filterByIndex].filterFunc)
        this.setState({ filteredProducts, categoryFilterIndex })
    }
    toggle(target) {
        const field = `dropdownOpen${target}`
        this.setState({ [field]: !this.state[field] })
    }

    render() {

        const { notifications, searchedNotifications } = this.state
            , onScreenSearchedNotifications = searchedNotifications ? searchedNotifications : notifications
            , searching = !!searchedNotifications
            , { filteredProducts } = this.state
            , filteredProductIds = filteredProducts.map(p => p.data._id)
            , onScreenNotifications = onScreenSearchedNotifications.filter(n => -1 !== filteredProductIds.indexOf(n.data._id))

        const { error, editNotificationError, categories, addNotificationError } = this.props;
        let notificationListItems = [];


        if (onScreenNotifications.length) {

            notificationListItems = onScreenNotifications.map((notification, index) => {
                const cat = categories.find(c => c._id === notification.data.category)
                    , category = cat ? cat.name : ''
                return <NotificationListItem index={onScreenNotifications.length - index} key={notification.data._id} notification={notification.data} category={category} active={notification.active} onActiveSwitch={this.onActiveSwitch} editNotification={this.editNotification} deleteNotification={this.confirmDeleteModalShow} />;
            });
            notificationListItems.reverse();

        }

        return <div>
            <Header />
            <Subheader search={true} breadcrumbs={["Notifications"]} onSearch={this.onSearch} />
            <div className="container">
                <div className="items-list-filters mt-5 align-items-center justify-content-between">
                    {error ? <Alert message={error} /> : null}
                    <h4 className="mb-0">Locations List ({notifications.length})</h4>
                    <FilterSorter options={
                        [
                            {
                                type: "dropdown",
                                name: "categoy",
                                title: "Category",
                                selectedIndex: this.state.categoryFilterIndex,
                                items: this.categoryFilterItems,
                                isOpen: this.state[`dropdownOpencategory`],
                                toggle: () => this.toggle('category')
                            },
                            // {
                            //     type: "dropdown",
                            //     name: "sortby",
                            //     title: "Sort by",
                            //     selectedIndex: this.state.sortByIndex,
                            //     items: this.sortbyItems,
                            //     isOpen: this.state[`dropdownOpensortby`],
                            //     toggle: () => this.toggle('sortby')
                            // },
                            {
                                type: "dropdown",
                                name: "show",
                                title: "Show",
                                selectedIndex: this.state.filterByIndex,
                                items: this.filterByItems,
                                isOpen: this.state[`dropdownOpenshow`],
                                toggle: () => this.toggle('show')
                            },

                        ]
                    } />
                    <button className="btn btn-space btn-primary" disabled={!this.getSubscriptionByDomainConstantCanUpload('NOTIFICATIONS') ? 'disabled' : ''} onClick={this.toggleNewNotificationModalOpen}><i className="icon icon-left s7-plus"></i> New Location</button>
                </div>
                {notificationListItems.length ? (
                    <div className="items-list items-list--notifications">
                        <div className="items-labels">
                            <div className="items-label-index">#</div>
                            <div className="list-item-1">Location details</div>
                            <div className="list-item-2">Range</div>
                            <div className="list-item-3">Other details</div>
                            <div className="list-item-4">Alert</div>
                            <div className="list-item-5">Actions</div>
                        </div>
                        {notificationListItems}
                    </div>
                ) : <p className="mt-5">{searching ? 'No notifications matching' : 'You have no notifications.'}</p>}
                {/* <div className="list-pagination d-flex justify-content-between">
                    <p>Showing 1 to 6 of 57 entries</p>
                    <nav>
                        <ul className="pagination pagination-rounded">
                            <li className="page-item"><a href="#" aria-label="Previous" className="page-link"><span aria-hidden="true" className="s7-angle-left"></span></a></li>
                            <li className="page-item"><a href="#" className="page-link">1</a></li>
                            <li className="page-item active"><a href="#" className="page-link">2</a></li>
                            <li className="page-item"><a href="#" className="page-link">3</a></li>
                            <li className="page-item"><a href="#" className="page-link">4</a></li>
                            <li className="page-item"><a href="#" aria-label="Next" className="page-link"><span aria-hidden="true" className="s7-angle-right"></span></a></li>
                        </ul>
                    </nav>
                </div> */}
            </div>

            <Modal isOpen={this.state.newNotificationModalOpen} toggle={this.toggleNewNotificationModalOpen} className="modal-md notif-modal">
                <div className="modal-header">
                    <div className="d-flex flex-row justify-content-between align-items-start w-100 mb-4 p-4">
                        <div>
                            <h3 className="mb-1">Create New Location</h3>
                            <h5 className="fw-100">Set Location Details</h5>
                        </div>
                        <h3>
                            <div onClick={this.toggleNewNotificationModalOpen} className="s7-close modal-close"></div>
                        </h3>
                    </div>
                </div>
                <ModalBody className="pt-0">
                    {addNotificationError ? <Alert message={addNotificationError} /> : null}
                    <label className="mt-3">Location name (ex: Starbucks, Iulius Mall)</label>
                    <input type="text" placeholder="Name" className="form-control form-control-xs mb-4" value={this.state.name} onChange={this.updateName} />
                    <div className="d-flex align-items-center mb-4">
                        <label className="mr-5 mb-0 text-md">Location photo</label>
                        <div className="d-flex justify-content-center mb-0 mr-3">
                            <Dropzone
                                onDrop={(accepted, rejected) => { this.onDropNotificationImage(accepted, rejected) }}
                                className="btn btn-rounded btn-space btn-secondary">
                                Upload from Computer
                            </Dropzone>
                        </div>
                        <label>{this.state.acceptedNotificationImage[0] ? this.state.acceptedNotificationImage[0].name : 'None'}</label>
                    </div>
                    <label>Type / Category</label>
                    <Select
                        name="product-category"
                        className="advanced-select mb-4"
                        value={this.state.category}
                        onChange={this.updateCategory}
                        options={this.state.categoryOptions}
                    />
                    <label>Phone Number</label>
                    <input type="text" placeholder="Phone number" className="form-control form-control-xs mb-4" value={this.state.phone} onChange={this.updatePhone} />
                    <label>Email</label>
                    <input type="email" placeholder="Your email" className="form-control form-control-xs mb-4" value={this.state.email} onChange={this.updateEmail} />
                    <label>WWW link</label>
                    <input type="text" placeholder="Link" className="form-control form-control-xs mb-4" value={this.state.link} onChange={this.updateLink} />
                    <label>Details</label>
                    <textarea className="form-control mb-4" rows="9" placeholder="Details" value={this.state.details} onChange={this.updateDetails}></textarea>
                    <label>Radius (meters)</label>
                    <input type="text" placeholder="Radius" className="form-control form-control-xs mb-4" value={this.state.radius} onChange={this.updateRadius} />
                    <label>Search for an address and the location will be where the marker is</label>
                    <MapWithASearchBox onSetMarker={(position) => { this.updateLocation(position) }} />
                    <p className="mt-3">{this.state.address}</p>
                    <button className="btn btn-space btn-primary" onClick={this.addNewNotification}>Add New Location</button>
                </ModalBody>
            </Modal>

            <Modal isOpen={this.state.editNotificationModalOpen} toggle={this.toggleEditNotificationModalOpen} className="modal-md notif-modal">
                <div className="modal-header">
                    <div className="d-flex flex-row justify-content-between align-items-start w-100 mb-4 p-4">
                        <div>
                            <h3 className="mb-1">Edit Location</h3>
                            <h5 className="fw-100">Update Location Details</h5>
                        </div>
                        <h3>
                            <span onClick={this.toggleEditNotificationModalOpen} className="s7-close modal-close"></span>
                        </h3>
                    </div>
                </div>
                <ModalBody className="pt-0">
                    {editNotificationError ? <Alert message={editNotificationError} /> : null}
                    <label className="mt-3">Location name (ex: Starbucks, Iulius Mall)</label>
                    <input type="text" placeholder="Name" className="form-control form-control-xs mb-4" value={this.state.nameEdit} onChange={this.updateNameEdit} />
                    <div className="d-flex align-items-center mb-4">
                        <label className="mr-5 mb-0">Location photo</label>
                        <div className="d-flex justify-content-center mb-0 mr-3">
                            <Dropzone
                                onDrop={(accepted, rejected) => { this.onDropNotificationImageEdit(accepted, rejected) }}
                                className="btn btn-rounded btn-space btn-secondary">
                                Upload from Computer
                            </Dropzone>
                        </div>
                        <label>{this.state.acceptedNotificationImageEdit[0] ? this.state.acceptedNotificationImageEdit[0].name : 'None'}</label>
                    </div>
                    <label>Type / Category</label>
                    <Select
                        name="product-category"
                        className="advanced-select mb-4"
                        value={this.state.categoryEdit}
                        onChange={this.updateCategoryEdit}
                        options={this.state.categoryOptions}
                    />
                    <label>Phone Number</label>
                    <input type="text" placeholder="Phone number" className="form-control form-control-xs mb-4" value={this.state.phoneEdit} onChange={this.updatePhoneEdit} />
                    <label>Email</label>
                    <input type="email" placeholder="Your email" className="form-control form-control-xs mb-4" value={this.state.emailEdit} onChange={this.updateEmailEdit} />
                    <label>WWW link</label>
                    <input type="text" placeholder="Link" className="form-control form-control-xs mb-4" value={this.state.linkEdit} onChange={this.updateLinkEdit} />
                    <label>Details</label>
                    <textarea className="form-control mb-4" rows="9" placeholder="Details" value={this.state.detailsEdit} onChange={this.updateDetailsEdit}></textarea>
                    <label>Radius (meters)</label>
                    <input type="text" placeholder="Radius" className="form-control form-control-xs mb-4" value={this.state.radiusEdit} onChange={this.updateRadiusEdit} />
                    <label>Search for an address and the location will be where the marker is</label>
                    <MapWithASearchBox onSetMarker={(position) => { this.updateLocationEdit(position) }} />
                    <p className="mt-3">{this.state.addressEdit}</p>
                    <button className="btn btn-space btn-primary" onClick={this.editNotificationConfirm}>Update Location</button>
                </ModalBody>
            </Modal>

            <Dialog open={this.state.confirmDeleteModalOpen} proceed={this.confirmDeleteModalProceed} cancel={this.confirmDeleteModalHide} message="This item won't be retreivable after deletion." />
            <Footer />
        </div>;
    }

}

export default connect(
    (state, ownProps) => {
        const { notifications: { requesting, notifications, adding, editing, categories, total, error, editNotificationError, addNotificationError }, userStatus: { subscriptions } } = state
        return { requesting, notifications, adding, editing, categories, total, error, subscriptions, editNotificationError, addNotificationError }
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps)
    }
)(withRouter(NotificationsPage))



// WEBPACK FOOTER //
// ./src/containers/Notification/Notifications.js